import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useWatch } from 'react-hook-form';
import { executeApiAction } from 'features/shared/utility/apiHelper';
import { findAddressDuplicates } from '../services/addressService';
import {
  getAddressDuplicateParams,
  buildAddressDuplicateQuery,
  hasAddressDuplicateParams,
} from '../utility/addressDuplicateHelper';

export const useAddressDuplicates = (control, addressId) => {
  const rules = useSelector((state) => state.duplicateForm.duplicatesParams.addduplicate);
  const values = useWatch({ control });
  const params = useMemo(() => getAddressDuplicateParams(rules), [rules]);
  const queryText = JSON.stringify(buildAddressDuplicateQuery(values));
  const [duplicates, setDuplicates] = useState([]);

  useEffect(() => {
    let active = true;
    setDuplicates([]);
    const query = JSON.parse(queryText);
    if (addressId || !hasAddressDuplicateParams(params, query)) return undefined;

    const timer = setTimeout(() => {
      executeApiAction({
        action: () => findAddressDuplicates(query),
        onSuccess: (rows) => {
          if (active) setDuplicates(Array.isArray(rows) ? rows : []);
        },
      });
    }, 500);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [queryText, params, addressId]);

  return { duplicates, duplicateParams: params };
};
